import React, { useContext, useEffect } from "react";
import { Container, Col, Button, Form, Row, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";

import WalletItem from "../Wallet/Component/WalletItem";
import OrderItem from "../UserOrder/Component/OrderItemTile";
import ContextApp from "./../../../core/contexts/context.app";
import SplitNumber from "../../components/SplitNumber";
import ApiAuth from "../../../core/api/api.auth";
import ServiceStorage from "../../../core/services/service.storage";
import { ToastContainer } from "react-toastify";

import {
  IconClipBoard,
  IconLogout,
  IconWallet,
  IconUserProfile,
  IconWalletDeposit,
  IconWalletWithdraw,
  IconWalletRequest,
  IconWalletTransition,
  IconOrderAll,
  IconOrderCancle,
  IconOrderDown,
  IconOrderWaiting,
  IconOrder,
  IconWallet1,
} from "../../../assets/icons";
const iconWalletDeposit = <IconWalletDeposit />;
const iconWalletTransition = <IconWalletTransition />;
const iconWalletRequest = <IconWalletRequest />;
const iconWalletWithdraw = <IconWalletWithdraw />;
const orderAllIcon = <IconOrderAll />;
const orderCancelIcon = <IconOrderCancle />;
const orderDoneIcon = <IconOrderDown />;
const orderWaitingIcon = <IconOrderWaiting />;

function Profile() {
  const ctx = useContext(ContextApp);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {})();
  }, [ctx.isAuth]);

  function signOut() {
    //
    ApiAuth.logout({
      refreshToken: ServiceStorage.getRefreshToken(),
    });

    ctx.setIsAuth(false);
    navigate("/login");
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <ToastContainer></ToastContainer> */}
      {isMobile ? (
        // حالت موبایل***********************************************
        <Container fluid className="main-content bg-light-3 vh-100">
          <Col xs={12} lg={4} className="pt-3 mt-lg-0 px-0 pl-lg-3">
            <Card className="rounded-3 ">
              <Card.Body>
                <Row className="pb-3">
                  <Col xs="auto" className="pl-0 my-auto profile-svg">
                    <IconUserProfile />
                  </Col>
                  <Col className=" my-auto">
                    <Form.Group>
                      <Form.Control
                        className="rounded-pill bg-white mb-2"
                        type="text"
                        value={ctx.userInfo?.name}
                        disabled
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Control
                        className="rounded-pill bg-white"
                        type="text"
                        value={ctx.userInfo?.phone}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12 border-top pt-3">
                    <IconWallet fillColor="#444" /> موجودی کیف پول
                    <SplitNumber
                      number={ctx.userInfo?.walletRiallBalance + " تومان"}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <Card className="rounded-3  mt-3">
              <Card.Body>
                <div className="mb-3 pb-3 border-bottom">
                  <span className="bg-light rounded-2 d-inline-block px-2 py-1">
                    <IconClipBoard />
                  </span>
                  <Link className="mx-3 text-dark " to="/order">
                    مشاهده لیست سفارش ها
                  </Link>
                </div>
                <div className="mb-3 pb-3 border-bottom">
                  <span className="bg-light rounded-2 d-inline-block px-2 py-1">
                    <IconWallet fillColor="#000" />
                  </span>
                  <Link className="mx-3 text-dark" to="/wallet">
                    مشاهده کیف پول
                  </Link>
                </div>
                <div>
                  <span className="bg-light rounded-2 d-inline-block px-2 py-1">
                    <IconLogout fillColor="#000" />
                  </span>
                  <button
                    className="btn-no-style px-0 mx-3 text-dark"
                    to="/wallet"
                    onClick={signOut}
                  >
                    خروج از حساب کاربری
                  </button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Container>
      ) : (
        // حالت دسکتاپ***********************************************

        <Container fluid className="bg-light-3 min-height-page">
          <Container className="mt-5">
            <Row className="pt-5">
              <Col xs={12} lg={4} className="pb-3 pb-lg-0">
                <div className="bg-light-blue rounded-4 p-3 ">
                  <div className="d-flex align-items-center pb-3">
                    <div className="profile-svg">
                      <IconUserProfile />
                    </div>
                    <div className="ms-3">
                      <div>
                        <span className="fs-09 text-dray">نام :</span>{" "}
                        {ctx.userInfo?.name}
                      </div>
                      <div>
                        <span className="fs-09 text-dray"> موبایل :</span>
                        {ctx.userInfo?.phone}
                      </div>
                    </div>
                  </div>

                  <Col
                    xs={12}
                    className="pt-3 border-top border-secondary border-secondary-subtle"
                  >
                    <Button
                      variant="outline-primary border-0"
                      className="rounded-2 fs-09 px-3"
                      onClick={signOut}
                    >
                      {/* <BoxArrowRight size={15} /> */}
                      <IconLogout />
                      <span className="ps-1">خروج از حساب کاربری</span>
                    </Button>
                  </Col>
                </div>
              </Col>
              <Col md="6" lg={4} className="icon-menu">
                <div className="bg-light-blue p-3 border mb-3 mt-1 rounded-4">
                  <div className="d-flex">
                    <div className="large-icons">
                      <IconWallet1 />
                    </div>
                    <div className="ms-3">
                      <div className="fw-bold text-large">
                        <SplitNumber
                          number={ctx.userInfo?.walletRiallBalance + " تومان"}
                        />
                      </div>
                      <div className="text-gray fs-08">موجودی کیف پول</div>
                    </div>
                  </div>
                </div>
                <Row className="fs-08 gx-3">
                  <WalletItem
                    Icon={iconWalletDeposit}
                    PageLink="/profile"
                    Title="شارژ کیف پول"
                    Event={1}
                  />
                  <WalletItem
                    Icon={iconWalletWithdraw}
                    PageLink="/profile"
                    Title="برداشت وجه"
                    Event={2}
                    RiallBalance={ctx.userInfo?.walletAvailableRiallBalance}
                  />
                  <WalletItem
                    Icon={iconWalletRequest}
                    PageLink="/withdrow"
                    Title="درخواست های برداشت"
                  />
                  <WalletItem
                    Icon={iconWalletTransition}
                    PageLink="/transaction"
                    Title="تراکنش های کیف پول"
                  />
                </Row>
              </Col>
              <Col md="6" lg={4} className="icon-menu">
                <div className="bg-light-blue p-3 border mb-3 mt-1 rounded-4">
                  <div className="d-flex">
                    <div className="large-icons">
                      <IconOrder />
                    </div>
                    <div className="ms-3">
                      <div className="fw-bold text-large">
                        {ctx.userInfo?.basketCount + " سفارش "}{" "}
                      </div>
                      <div className="text-gray fs-08">تعداد کل سفارشات </div>
                    </div>
                  </div>
                </div>
                <Row className="gx-3 fs-08">
                  <OrderItem
                    PageLink="/order/orderList"
                    Icon={orderAllIcon}
                    title="همه سفارشها"
                    statusList={[0, 1, 2, 3]}
                  />
                  <OrderItem
                    PageLink="/order/orderList"
                    Icon={orderWaitingIcon}
                    title="جدید و در حال پردازش"
                    statusList={[0, 2]}
                  />
                  <OrderItem
                    PageLink="/order/orderList"
                    Icon={orderDoneIcon}
                    title="انجام شده"
                    statusList={[1]}
                  />
                  <OrderItem
                    PageLink="/order/orderList"
                    Icon={orderCancelIcon}
                    title="لغو شده"
                    statusList={[3]}
                  />
                </Row>
              </Col>
            </Row>
          </Container>
        </Container>
      )}
    </>
  );
}
export default Profile;
